import { render, staticRenderFns } from "./Wavesurfer.vue?vue&type=template&id=7af9e11d&"
import script from "./Wavesurfer.vue?vue&type=script&lang=js&"
export * from "./Wavesurfer.vue?vue&type=script&lang=js&"
import style0 from "./Wavesurfer.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports